/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_LoadingInputs */

const en_home_loading = /** @type {(inputs: Home_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading apartments…`)
};

/**
* | output |
* | --- |
* | "Loading apartments…" |
*
* @param {Home_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_loading = /** @type {((inputs?: Home_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_loading(inputs)
});